import { __assign, __rest } from "tslib";
import React from 'react';
import { CheckGroupBase } from '../internal/CheckGroupBase/CheckGroupBase';
import { Radio } from '../Radio/Radio';
import { useControlledRadiobuttonGroup } from '../internal/utils/useControlledRadiobuttonGroup';
import { forwardRefForInputGroup } from '../../internal/forwardInputGroupRef/forwardInputGroupRef';
export var RadioGroup = forwardRefForInputGroup(function (_a, ref) {
    var valueProp = _a.value, defaultValueProp = _a.defaultValue, name = _a.name, onChange = _a.onChange, restProps = __rest(_a, ["value", "defaultValue", "name", "onChange"]);
    var getOptionProps = useControlledRadiobuttonGroup({
        value: valueProp,
        defaultValue: defaultValueProp,
        changeHandler: onChange,
        componentName: 'RadioGroup',
        nameAttribute: name,
    }).getOptionProps;
    var renderOption = function (option) {
        return React.createElement(Radio, __assign({}, getOptionProps(option)));
    };
    return (React.createElement(CheckGroupBase, __assign({}, restProps, { name: name, renderOption: renderOption, ref: ref })));
});
//# sourceMappingURL=RadioGroup.js.map